export const REQUEST_ACTIVATION_STATUS = 'REQUEST_ACTIVATION_STATUS';
export const RECEIVE_ACTIVATION_STATUS = 'RECEIVE_ACTIVATION_STATUS';
export const REQUEST_ACTIVATION = 'REQUEST_ACTIVATION';
export const RECEIVE_ACTIVATION = 'RECEIVE_ACTIVATION';
export const REQUEST_DATA_EXTENSION = 'REQUEST_DATA_EXTENSION';
export const RECEIVE_DATA_EXTENSION = 'RECEIVE_DATA_EXTENSION';
export const REQUEST_FREQUENCIES = 'REQUEST_FREQUENCIES';
export const RECEIVE_FREQUENCIES = 'RECEIVE_FREQUENCIES';
export const REQUEST_UPDATE_DATA_EXTENSION = 'REQUEST_UPDATE_DATA_EXTENSION';
export const RECEIVE_UPDATE_DATA_EXTENSION = 'RECEIVE_UPDATE_DATA_EXTENSION';
export const REQUEST_CREATE_DATA_EXTENSION = 'REQUEST_CREATE_DATA_EXTENSION';
export const RECEIVE_CREATE_DATA_EXTENSION = 'RECEIVE_CREATE_DATA_EXTENSION';
export const UPDATE_DATA_FILTER = 'UPDATE_DATA_FILTER';
export const UPDATE_ADVANCED_SLIDERS = 'UPDATE_ADVANCED_SLIDERS';
export const UPDATE_CHART_PARAMS = 'UPDATE_CHART_PARAMS';
export const REQUEST_EINSTEIN_RECOMMENDATIONS =
  'REQUEST_EINSTEIN_RECOMMENDATIONS';
export const RECEIVE_EINSTEIN_RECOMMENDATIONS =
  'RECEIVE_EINSTEIN_RECOMMENDATIONS';
export const UPDATE_FREQUENCY_RECS = 'UPDATE_FREQUENCY_RECS';
export const REQUEST_NOTIFICATION_EMAIL = 'REQUEST_NOTIFICATION_EMAIL';
export const RECEIVE_NOTIFICATION_EMAIL = 'RECEIVE_NOTIFICATION_EMAIL';
export const REQUEST_UPDATE_NOTIFICATION_EMAIL =
  'REQUEST_UPDATE_NOTIFICATION_EMAIL';
export const RECEIVE_UPDATE_NOTIFICATION_EMAIL =
  'RECEIVE_UPDATE_NOTIFICATION_EMAIL';
export const REQUEST_NEW_DASHBOARD_FEATURE_FLAG =
  'REQUEST_NEW_DASHBOARD_FEATURE_FLAG';
export const RECEIVE_NEW_DASHBOARD_FEATURE_FLAG =
  'RECEIVE_NEW_DASHBOARD_FEATURE_FLAG';
export const REQUEST_EEF_V2_PROVISIONED_STATUS =
  'REQUEST_EEF_V2_PROVISIONED_STATUS';
export const RECEIVE_EEF_V2_PROVISIONED_STATUS =
  'RECEIVE_EEF_V2_PROVISIONED_STATUS';
export const ENGAGEMENT_FREQUENCY_LINK = '/EinsteinEngagementFrequency';
export const SETUP_APP = 'Setup';

export const RECOMMENDATION_STATUS = {
  ok: 'ok',
  no_data: 'no_data',
  no_recommendation: 'no_recommendation',
  insufficient_data: 'insufficient_data'
};
